/*
 * @Author: heyu tao
 * @since: 2021-09-08 14:24:12
 * @LastAuthor: CDS
 * @lastTime: 2022-07-20 11:00:34
 * @message: file content
 * @The path of the file relative to the project: /cds-portal-web/src/utils/secret.js
 */
const CryptoJS = require('crypto-js') // 引用AES源码js

function getRamNumber() {
  var result = ''
  for (var i = 0; i < 16; i++) {
    result += Math.floor(Math.random() * 16).toString(16)// 获取0-15并通过toString转16进制
  }
  // 默认字母小写，手动转大写
  return result.toUpperCase()// 另toLowerCase()转小写
}
//   const key = CryptoJS.enc.Utf8.parse('1999111000ABDCFE') //十六位十六进制数作为密钥
// const iv = CryptoJS.enc.Utf8.parse('BADCFE1999111000') //十六位十六进制数作为密钥偏移量

const keyStr = getRamNumber()
const ivStr = getRamNumber()
const key = CryptoJS.enc.Utf8.parse('1999111000ABDCFE') // 十六位十六进制数作为密钥
const iv = CryptoJS.enc.Utf8.parse('BADCFE1999111000') 

// 解密方法
function Decrypt(word) {
  //const key = CryptoJS.enc.Utf8.parse(word.slice(0, 16)) // 十六位十六进制数作为密钥
  //const iv = CryptoJS.enc.Utf8.parse(word.slice(16, 32)) // 十六位十六进制数作为密钥偏移量
  const strword = word //.slice(32)
  const encryptedHexStr = CryptoJS.enc.Hex.parse(strword)
  const srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr)
  const decrypt = CryptoJS.AES.decrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })

  const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
  console.log(decryptedStr)
  return decryptedStr.toString()
}

// 加密方法
function Encrypt(word) {
  const srcs = CryptoJS.enc.Utf8.parse(word)
  const encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return  encrypted.ciphertext.toString().toUpperCase()
  // return word
}

module.exports = {
  Decrypt,
  Encrypt
}
